import AppSpinner from "./AppSpinner.vue";

export default {
  extends: AppSpinner
};
